import Breadcrumb from '../../core/components/UI/Breadcrumb'
import FormMineralValueChainEdit from '../components/mineral-value-chain-edit-page/FormMineralValueChainEdit'
import LoaderMineralValueChainEditForm from '../components/mineral-value-chain-edit-page/LoaderMineralValueChainEditForm'
import { useMineralContext } from '../context/mineral/mineralProvider'

export default function MineralValueChainEditPage() {
  const { mineralState } = useMineralContext()

  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المعادن',
            isActive: false,
            to: '/minerals',
          },
          {
            id: 2,
            label: mineralState.mineral?.name_ar,
            isActive: false,
            to: `/minerals/${mineralState.mineral?.id}`,
          },
          {
            id: 3,
            label: 'سلسلة القيمة',
            isActive: false,
          },
          {
            id: 4,
            label: 'تعديل',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        {mineralState.isLoading ? (
          <LoaderMineralValueChainEditForm />
        ) : (
          <FormMineralValueChainEdit mineral={mineralState.mineral} />
        )}
      </div>
    </>
  )
}
